import { render } from "./new-admin.vue?vue&type=template&id=d708fc36"
import script from "./new-admin.vue?vue&type=script&lang=js"
export * from "./new-admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__